/**
 * FlahaSOIL v2 — Texture triangle chart adapter (Phase 10C-D).
 */
import type { TextureAnalysisBlock } from "@flaha/shared-types";
import type { ScientificChartData, ScientificChartStatus } from "../types/ScientificChartTypes";
import { CHART_UNITS } from "../utils/chartUnits";

export function textureTriangleChartAdapter(
  texture: TextureAnalysisBlock | null
): ScientificChartData<TextureAnalysisBlock | null> {
  const warnings: string[] = [];
  let status: ScientificChartStatus = "READY";

  if (!texture) {
    status = "MISSING_DATA";
  } else if (!texture.sumOk) {
    status = "METHOD_WARNING";
    warnings.push(`Texture fractions sum to ${(100 + texture.sumDelta).toFixed(1)}% — engine normalised before plotting.`);
  }

  const title = "USDA Texture Triangle";
  const description = "Sand / silt / clay classification based on the USDA Soil Survey Manual.";
  const source = "USDA / Saxton-Rawls (2006)";

  let accessibilitySummary = "USDA soil texture triangle chart.";
  if (texture) {
    accessibilitySummary = `Soil texture is classified as ${texture.classification}. Composition: sand ${texture.normalized.sand.toFixed(1)}%, silt ${texture.normalized.silt.toFixed(1)}%, clay ${texture.normalized.clay.toFixed(1)}%.`;
  } else {
    accessibilitySummary = "No texture data available to plot.";
  }

  return {
    status,
    title,
    description,
    data: texture,
    warnings,
    units: {
      sand: CHART_UNITS.percent,
      silt: CHART_UNITS.percent,
      clay: CHART_UNITS.percent,
    },
    source,
    accessibilitySummary,
  };
}
